<template>
  <validation-observer
    ref="observer"
    tag="form">
    <div class="address-inputs">
      <oie-address-component id="checkout-new-address" :address="newAddress"></oie-address-component>

      <div class="address-inputs__actions">
        <oie-base-button
          css-classes="button--with-border button--blue"
          :text="t('deliveryAddressSaveButtonLabel')"
          @click="createAddress">
        </oie-base-button>

        <button type="button" class="adress-inputs__cancel" @click="closeEditor">
          {{ tStatic('closeLink') }}
        </button>
      </div>
    </div>
  </validation-observer>
</template>
<script>
import httpService from '@/core/http-service'
import _ from 'lodash'

export default {
  props: {
    address: {
      type: Object,
      required: false,
      default: null
    },
    customer: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    newAddress: {}
  }),
  mounted() {
    this.newAddress = this.createNewAddress()
  },
  methods: {
    closeEditor() {
      this.publish('new.address.accordion.toggle', false)
    },
    createAddress() {
      this.$refs.observer.validate().then((valid) => {
        if(valid) {
          httpService.post('auth/createAddress', {
            ...this.newAddress,
            isShippingAddress: true
          })
            .then((response) => {
              _.merge(this.address, this.newAddress)
              this.newAddress = this.createNewAddress()
              this.publish('new.address.accordion.toggle', false)
              this.publish('checkout-new-address', response.data)
            })
            .catch((error) => {
              console.error('failed updating address for user', error)
            })
        }
      })
    },
    createNewAddress() {
      return {
        name: null,
        addressLine1: null,
        addressCo: null,
        postalCode: null,
        city: null,
        countryCode: null,
        countryName: null
      }
    }
  }
}
</script>

<style lang="scss">
.address-inputs {
  width: 100%;
}

.address-inputs > *:not(:last-child) {
  margin-bottom: measure(half);
}

.address-inputs__actions {
  display: flex;
  align-items: center;
}

.adress-inputs__cancel {
  @include reset-button;
  height: 2.5rem;
  margin-left: measure(quarter);
  padding: 0 measure(quarter);
}
</style>
